import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=32b19d0c&scoped=true"
import script from "./AppAside.vue?vue&type=script&lang=js"
export * from "./AppAside.vue?vue&type=script&lang=js"
import style0 from "./AppAside.vue?vue&type=style&index=0&id=32b19d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b19d0c",
  null
  
)

export default component.exports